import harrisLogo from '../../assets/harris-loading.png';
import bpkLogo from '../../assets/billpaykiosk-logo.png';
import { store } from '../../lib/stores/store';
import { observer } from 'mobx-react-lite';
import style from './style.module.scss';

const LoaderScreen = observer(function LoaderScreen() {
	const {
		configStore: { getString },
	} = store;
	return (
		<main className={style.main}>
			<img className={style['main__loader-image']} src={harrisLogo} alt='Harris Logo' />
			<p className={style['main__loader-text']}>{getString('loader-message')}</p>
			<img className={style['main__footer']} src={bpkLogo} alt='Bill Pay Kiosk Logo' />
		</main>
	);
});

export default LoaderScreen;
